import {put, takeLatest, call} from 'redux-saga/effects';
import * as extraService from "../../../../services/extraService.js";
import {
    UNDELETE_EXTRA,
    GET_EXTRAS_SUCCESS,
    UNDELETE_EXTRA_ERROR,
}
    from "../../../actions/menu/extras";

function* unDeleteExtraSaga(action) {
    try {
        yield call(extraService.UnDeleteExtra, action.payload)
        yield put({
            type: GET_EXTRAS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_EXTRA_ERROR,error: error.data
        });
    }
}


export function* unDeleteExtraSagaWatcher() {
    yield takeLatest(UNDELETE_EXTRA, unDeleteExtraSaga);
}